module.exports = __webpack_public_path__ + "flowers2.bc6f21b825316057f3a4.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animations/flowers2.gif
// module id = ./src/assets/images/animations/flowers2.gif
// module chunks = main